import React, { useEffect } from "react";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Table, Card, Col, Form, Row, InputGroup } from "react-bootstrap";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import moment from "moment";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import { IconHistory, IconCalendarWeek, IconTrash } from "@tabler/icons-react";
import Lottie from "lottie-react";
import notfoundData from "../../assets/not_found.json";
import DatePicker from "react-datepicker";
import FileUpload from "../../components/Attachment/Attachment";
// GET_VERSION_RFQ

function PurchaseOrderPopUp({ show, setShow }) {
  return (
    <Modal
      show={show}
      onHide={() => setShow({ show: false })}
      className="skusearch"
      dialogClassName="modal-90vw"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header className="gap-2 align-items-center" closeButton>
        <span className="avatar bg-blue-lt rounded-circle">
          <IconHistory />
        </span>
        <div>
          <Modal.Title>Purchase Order </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Vendor</Form.Label>
              <InputGroup>
                <Form.Select
                // {...register("shipping_method")}
                >
                  <option value={""}>Select a method</option>
                  <option value={"UPS"}>UPS</option>
                  <option value={"FedEx"}>FedEx</option>
                  <option value={"Freight"}>Freight</option>
                  <option value={"Other"}>Other</option>
                </Form.Select>
              </InputGroup>
              {/* {errors.shipping_method && (
                  <span className="text-danger">
                    {errors.shipping_method.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                // {...register("estimateddelivery")}

                />
              </InputGroup>
              {/* {errors.estimateddelivery && (
                  <span className="text-danger">
                    {errors.estimateddelivery.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label className="required">Purchase Order Date</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconCalendarWeek stroke={1} />
                </InputGroup.Text>
                <Controller
                  name="publishedDate"
                  // control={control}
                  defaultValue={new Date()}
                  rules={{ required: "Published date is required" }}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      selected={field.value ? new Date(field.value) : new Date()}
                      onChange={(date) => field.onChange(date)}
                      dateFormat="MM/dd/yyyy"
                      minDate={new Date()}
                      placeholderText="Select Date"
                      className="form-control required"
                      yearDropdownItemNumber={20}
                      scrollableYearDropdown
                      showYearDropdown
                      showMonthDropdown
                    />
                  )}
                />
              </InputGroup>
              {/* {errors.publishedDate && (
                      <span className="text-danger">
                        {errors.publishedDate.message}
                      </span>
                    )} */}
            </Form.Group>
          </Col>
          <Col md={3}>
            <div>
              <span> Amount: </span> <spa>$2323</spa>
            </div>
          </Col>
        </Row>


        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Mailing Address</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  {/* <IconHomeSpark stroke={1} /> */}
                </InputGroup.Text>
                <Form.Control
                  as="textarea"
                  // {...register("contractOfficerAddress")}
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height to auto
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                  }}
                  placeholder="Mailing Address"
                />
              </InputGroup>
              {/* {errors.contractOfficerAddress && (
                  <span className="text-danger">
                    {errors.contractOfficerAddress.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Shipping Address</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  {/* <IconHomeSpark stroke={1} /> */}
                </InputGroup.Text>
                <Form.Control
                  as="textarea"
                  // {...register("contractOfficerAddress")}
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto";
                    e.target.style.height = `${e.target.scrollHeight}px`;
                  }}
                  placeholder="Shipping Address"
                />
              </InputGroup>
              {/* {errors.contractOfficerAddress && (
                  <span className="text-danger">
                    {errors.contractOfficerAddress.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Shipping to</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                // {...register("estimateddelivery")}
                />
              </InputGroup>
              {/* {errors.estimateddelivery && (
                  <span className="text-danger">
                    {errors.estimateddelivery.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Ship Via</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                // {...register("estimateddelivery")}
                />
              </InputGroup>
              {/* {errors.estimateddelivery && (
                  <span className="text-danger">
                    {errors.estimateddelivery.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>PO no.</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                // {...register("estimateddelivery")}
                />
              </InputGroup>
              {/* {errors.estimateddelivery && (
                  <span className="text-danger">
                    {errors.estimateddelivery.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>
        </Row>

        <div className="mail_wrapper">
          <Table bordered>
            <thead>
              <tr>
                <th>Sr.no.</th>
                <th>PRODUCT/SERVICES</th>
                <th>DESCRIPTION</th>
                <th>QTY</th>
                <th>RATE</th>
                <th>AMOUNT</th>
                <th>CUSTOMER</th>
                <th>ACTION</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td className={`d-flex gap-1 `}>
                  Soil
                </td>
                <td>
                  2 cubic ft. bag
                </td>
                <td>
                  5
                </td>
                <td>
                  66
                </td>
                <td>
                  266
                </td>
                <td>
                  bill windsurf Shop
                </td>
                <td>
                  <IconTrash />
                </td>
              </tr>
              <tr>
                <td colSpan={7} className="text-end">
                  Total
                </td>
                <td >
                  $440
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Your message to vendor</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  {/* <IconHomeSpark stroke={1} /> */}
                </InputGroup.Text>
                <Form.Control
                  as="textarea"
                  // {...register("contractOfficerAddress")}
                  style={{
                    height: "auto",
                    minHeight: "80px",
                    resize: "none",
                  }}
                  onInput={(e) => {
                    e.target.style.height = "auto"; // Reset height to auto
                    e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                  }}
                  placeholder="Mailing Address"
                />
              </InputGroup>
              {/* {errors.contractOfficerAddress && (
                  <span className="text-danger">
                    {errors.contractOfficerAddress.message}
                  </span>
                )} */}
            </Form.Group>
          </Col>
          <Col md={6}>
            <FileUpload/>
          </Col>
        </Row>

      </Modal.Body>
    </Modal>
  );
}
export default PurchaseOrderPopUp;
